import styled from "@emotion/styled";
import { motion, Transition } from "framer-motion";
import React from "react";
import { useRecoilValue } from "recoil";
import { billingAtom, newBillingAtom } from "../../../../../atoms/BillingAtom";
import IconBerserkerMail from "../../../../Icon";

const Card = styled.div`
  font: normal normal normal 16px/18px Lato;
  color: #555b5f;

  padding: 30px 30px 15px 30px;
  width: 100%;

  min-height: 150px;

  background: #f6f6f7 0% 0% no-repeat padding-box;
  border-radius: 8px;
`;

const Title = styled.div`
  font-weight: 600;
  font-size: 22px;
  display: flex;
`;

const CircleStyle = styled(motion.span)`
  display: block;
  width: 30px;
  height: 30px;
  border: 0.3rem solid #e9e9e9;
  border-top: 0.3rem solid #5fa200;
  border-radius: 50%;
  position: absolute;
  box-sizing: border-box;
`;

const spinTransition: Transition = {
  repeatType: "loop",
  ease: "linear",
  duration: 1,
  repeat: Infinity,
};

export default function CreditCardComponent() {
  const billing = useRecoilValue(newBillingAtom);

  return (
    <Card>
      {billing.card ? (
        <div>
          <Title>
            <IconBerserkerMail name="credit-card" width={25} color="#000000" />
            <div style={{ marginLeft: 10 }}>
              {billing.card?.card.brand[0].toUpperCase() +
                (billing.card?.card.brand.substring(1) || "")}{" "}
              ending in {billing.card?.card.last4}
            </div>
          </Title>
          <p>
            <b>{billing.cardName}</b>
            <br />
            {billing.billingInfo?.billing_address.street},{" "}
            {billing.billingInfo?.billing_address.city}{" "}
            {billing.billingInfo?.billing_address.state_region} <br />
            {billing.billingInfo?.billing_address.country}&nbsp;&nbsp;
            {billing.billingInfo?.billing_address.zip_code}
          </p>
        </div>
      ) : (
        <CircleStyle animate={{ rotate: 360 }} transition={spinTransition} />
      )}
    </Card>
  );
}
